<template>
  <div class="header-dropdown__container">
    <Avatar
      :text="user && user.userable ? user.userable.name.charAt(0) : ''"
      :avatarId="user.id" :height="30" :width="30" :textSize="12"
      class="header-avatar" :borderSize="2"
      @onClick="$router.push('/profile')"
      :imgSrc="user && user.userable && user.userable.photo ? `${photoBasePath}${user.userable.photo.hashName}` : ''"/>
    <b-dropdown right size="sm" no-caret class="header-dropdown" variant="light" toggle-class="test">
      <template #button-content>
        <v-icon name="caret-down" />
      </template>
      <b-dropdown-item @click="$router.push('/profile')">
        <div class="profile-dropdown-item">
          <Avatar
            :text="user && user.userable ? user.userable.name.charAt(0) : ''"
            :avatarId="user.id" :height="70" :width="70" :textSize="24"
            :imgSrc="user && user.userable && user.userable.photo ? `${photoBasePath}${user.userable.photo.hashName}` : ''" />
          <div class="profile-info-container">
            <div class="personnel-name">{{ user && user.userable ? user.userable.name : '' }}</div>
            <div class="personnel-see-profile">See your profile</div>
          </div>
        </div>
      </b-dropdown-item>
      <b-dropdown-divider />
      <b-dropdown-item @click="$emit('onLogoutUser')">
        <div class="profile-dropdown">
          Logout
        </div>
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
import Avatar from "../../views/components/Avatar";
import { AuthApi, ReportApi } from '../../mixins/api'
export default {
  components: {
    Avatar
  },
  mixins: [ AuthApi, ReportApi ],
  data() {
    return {
      isLoggingOut: false,
      photoBasePath: `${process.env.VUE_APP_PUBLIC_PHOTO_URL}personnels/`
    }
  },
  methods: {
  },
  computed: {
    user() {
      return this.$store.state.user || {}
    }
  }

}
</script>

<style lang="scss" scoped>

  .header-dropdown__container {
    width: auto;
    position: absolute;
    right: 10px;
    display: flex;
    align-items: center;

  }

  .header-dropdown {
    margin-left: 8px;
    
    
  }

  .header-avatar {
    &:hover {
      cursor: pointer;
    }
  }

  .profile-dropdown-item {
    height: 80px;
    width: 100%;
    display: flex;
    align-items: center;
  }
  
  .personnel-name {
    font-size: 14pt;
    font-weight: bold;
  }

  .personnel-see-profile {
    font-size: 10pt;
    color: gray;
    display: flex;
    align-items: center;
  } 

  .profile-info-container {
    width: 200px;
    margin-left: 10px;
  }

  .profile-dropdown {
    height: 40px ;
    display: flex;
    align-items: center;
    width: 100%;
    position: relative;
  }

  .logout-loading__icon {
    position: absolute;
    right: 25px;
  }

</style>